var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaches(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48.778,
    r: 48,
    fill: "#EED1A8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ge66sl5faa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.147 42.453a7.744 7.744 0 0 0 1.16-4.06c0-3.711-2.65-6.868-6.243-7.555-.47-7.8-7.06-14.06-14.934-14.06a14.968 14.968 0 0 0-11.848 5.824 11.79 11.79 0 0 0-7.52-2.696c-6.528 0-11.836 5.308-11.836 11.835 0 .495.034.994.092 1.485C19.8 35.115 17 39.396 17 44.042c0 6.527 5.308 11.835 11.843 11.835h.117l11.023.154v9.567h-6.119c-.424 0-.798.254-.96.645-.163.391-.071.836.228 1.136l13.195 13.103a1.033 1.033 0 0 0 1.465 0L60.986 67.38a1.04 1.04 0 0 0-.732-1.78h-6.12V56.23l16.636.233c4.239 0 7.692-3.448 7.692-7.691a7.72 7.72 0 0 0-3.308-6.32h-.008zm-22.06 5.54H41.023a.417.417 0 0 0-.416.417v6.173l-11.639-.162h-.133c-5.724 0-10.379-4.655-10.379-10.38 0-4.363 2.758-8.286 6.86-9.767a.414.414 0 0 0 .266-.474 10.306 10.306 0 0 1-.204-2.055c0-5.724 4.655-10.379 10.379-10.379 2.8 0 5.425 1.098 7.392 3.095a.407.407 0 0 0 .337.12.427.427 0 0 0 .308-.186 13.47 13.47 0 0 1 11.336-6.157c7.45 0 13.507 6.06 13.507 13.524 0 .22.17.4.39.416a6.246 6.246 0 0 1 5.829 6.219c0 1.51-.55 2.966-1.543 4.102a.416.416 0 0 0 .133.648 6.27 6.27 0 0 1 3.552 5.629c0 3.436-2.795 6.235-6.227 6.235l-17.268-.245v-6.352a.417.417 0 0 0-.416-.416v-.004zM41.023 67.05a.417.417 0 0 0 .416-.416V48.826h11.232v17.808c0 .229.187.416.416.416h6.153L47.055 79.151l-12.184-12.1h6.152z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ge66sl5faa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(17 16.778)",
    d: "M0 0h61.454v64H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaches);
export default __webpack_public_path__ + "static/media/caches.33eea69469835a52b500e9a0d95a0bdf.svg";
export { ForwardRef as ReactComponent };